var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokeball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 369,
    viewBox: "0 0 368 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_83_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.655 338.418C266.904 338.418 337.634 267.716 337.634 180.5C337.634 93.2842 266.904 22.5818 179.655 22.5818C92.4052 22.5818 21.6754 93.2842 21.6754 180.5C21.6754 267.716 92.4052 338.418 179.655 338.418Z",
    fill: "#1D1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.317 162.952C338.536 78.1388 266.829 12 179.655 12C92.48 12 20.7811 78.1388 12 162.952H347.317Z",
    fill: "#C5312A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 198.047C20.7811 282.86 92.4881 348.999 179.655 348.999C266.821 348.999 338.536 282.86 347.309 198.047H12V198.047Z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.654 233.593C208.988 233.593 232.767 209.822 232.767 180.5C232.767 151.178 208.988 127.407 179.654 127.407C150.32 127.407 126.54 151.178 126.54 180.5C126.54 209.822 150.32 233.593 179.654 233.593Z",
    fill: "#1D1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.23 195.841C226.702 174.554 216.308 150.431 195.012 141.962C173.717 133.492 149.585 143.883 141.112 165.17C132.639 186.457 143.034 210.58 164.329 219.049C185.625 227.519 209.757 217.128 218.23 195.841Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.657 208.485C195.118 208.485 207.652 195.956 207.652 180.501C207.652 165.046 195.118 152.517 179.657 152.517C164.196 152.517 151.662 165.046 151.662 180.501C151.662 195.956 164.196 208.485 179.657 208.485Z",
    fill: "#B8B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.657 206.424C193.979 206.424 205.589 194.818 205.589 180.502C205.589 166.185 193.979 154.579 179.657 154.579C165.335 154.579 153.724 166.185 153.724 180.502C153.724 194.818 165.335 206.424 179.657 206.424Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_83_1301",
    x: 0,
    y: 0,
    width: 367.317,
    height: 368.999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.109804 0 0 0 0 0.25098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_83_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_83_1301",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.11e69f662e3bde22e0ab2eb28e44dce6.svg";
export { ForwardRef as ReactComponent };